import { useParams } from "react-router-dom";
import MenuFrame from "../frames/menu_frame";

function OrgCnPickup(params) {
    const param = useParams();
    console.log(param);
    return (
        <MenuFrame>
            Pickup edit is not available. Please delete the pickup and add new pickup.
        </MenuFrame>
    );
}

export default OrgCnPickup;